"use strict";

new Vue({
  mixins: [main],
  data: function data() {
    return {
      post: undefined,
      newsItems: [],
      arrivalItems: [],
      id: apiId,
      areas: areas,
      area: undefined,
      areaName: undefined,
      isOnline: false,
      preview: preview,
      loading: true,
      newsLoading: true,
      arrivalLoading: true
    };
  },
  methods: {
    setSeoSetting: function setSeoSetting(post) {
      $('title').text(this.areaName + 'の同人誌・アニメグッズや中古ゲームの買取 | ' + this.post.name);
      $('meta[name="description"]').attr('content', this.areaName + '近辺で中古同人誌やアニメグッズを売る、買うなら' + post.name + 'へ。中古のアニメグッズやDVD、ブルーレイ（Blu-ray)の宅配買取や中古販売はらしんばんにお任せください。中古の同人誌やCD、本や書籍、アニメ系のグッズを売りたい方も、買いたい方も充実のラインナップでお待ちしています。');

      if (post.pr.img && post.pr.img[0]) {
        $('meta[property="og:image"], meta[name="twitter:image"]').attr('content', olineImgUrl + '/' + post.pr.img[0]);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    axios.get(apiUrl + '/api/get_store', {
      params: {
        id: this.id,
        preview: this.preview
      }
    }).then(function (response) {
      if (!response.data.items[0]) {
        _this.readySingle(_this.post, true);

        _this.loading = false;
        return;
      }

      _this.post = response.data.items[0];

      _this.post.banner.filter(function (banner) {
        return banner.image;
      });

      _this.post.floor.filter(function (floor) {
        return floor.img || floor.text;
      });

      _this.post.guide.filter(function (guide) {
        return guide.img || guide.text;
      });

      _this.area = _this.areas[_this.post.area];
      _this.areaName = _this.area === 'オンライン' ? 'らしんばんオンライン' : _this.area;
      _this.isOnline = _this.area === 'オンライン';

      _this.readySingle(_this.post);

      _this.loading = false;

      _this.$nextTick(function () {
        initSlick('list');
        initSlick('store_banner');
        initGallary();
        initFloorModal();

        _this.initTwitter();
      });

      axios.get(apiUrl + '/api/get_news', {
        params: {
          store_type_all: '1',
          store: _this.id,
          number: 6
        }
      }).then(function (response) {
        _this.newsItems = response.data.items.map(function (item) {
          return {
            title: item.title,
            category: {
              id: item.category.id,
              name: item.category.name,
              url: '/news/?category=' + item.category.id
            },
            date: item.date,
            url: '/news/' + item.id + '/'
          };
        });

        if (_this.newsItems.length) {
          _this.newsItems = [_this.newsItems.slice(0, 3), _this.newsItems.slice(3)];
        }

        _this.newsLoading = false;
      });

      if (_this.post.type !== 2) {
        axios.get(apiUrl + '/api/get_arrival', {
          params: {
            store: _this.id,
            number: 10
          }
        }).then(function (response) {
          _this.arrivalItems = response.data.items.map(function (item) {
            return {
              name: item.title,
              img: item.thumbnail ? olineImgUrl + '/' + item.thumbnail : templateDirectoryUri + '/img/no_image_arrival_s.jpg',
              url: '/arrival/' + item.id + '/',
              r18Flag: item.r18_flag
            };
          });
          _this.arrivalLoading = false;

          _this.$nextTick(function () {
            initSlick('list');
          });
        });
      }
    });
  }
});